import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { Field } from "formik";
import { Icon, HoverForHelp } from "components/common";
import { TimeUnits } from "views/Constants";
import { FormControl, Checkbox, MenuItem, InputGroup, Input } from "components/bootstrap";
import DropdownButton from "components/bootstrap/DropdownButton";
const RangeSelect = styled.div`
  display: flex;
  align-items: center;
`;
const CurrentScale = styled.div`
  min-width: 30px;
  margin-left: 5px;
  text-align: right;
`;
const TypeCheckboxWrapper = styled.div`
  margin-bottom: 5px;
`;
const IntervalCheckboxDescWithHelp = styled.div`
  display: flex;
  align-items: center;
`;
const IntervalHoverForHelp = styled(HoverForHelp)`
  margin-left: 5px;
`;
const TIME_UNIT_LABELS = {
  seconds: "wizard_units.time_units.seconds",
  minutes: "wizard_units.time_units.minutes",
  hours: "wizard_units.time_units.hours",
  days: "wizard_units.time_units.days",
  weeks: "wizard_units.time_units.weeks",
  months: "wizard_units.time_units.months"
};
const IntervalCheckboxDesc = () => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement(IntervalCheckboxDescWithHelp, null, t("wizard_grouping.auto"), /* @__PURE__ */ React.createElement(IntervalHoverForHelp, { title: t("wizard_grouping.interval_types") }, /* @__PURE__ */ React.createElement("ul", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("h4", null, t("wizard_grouping.auto_bucket_size")), /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "wizard_grouping.auto_bucket_size_help", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("h4", null, t("wizard_grouping.fixed_bucket_size")), t("wizard_grouping.fixed_bucket_size_help")))));
};
const toggleIntervalType = (name, currentType, onChange) => {
  if (currentType === "auto") {
    onChange({ target: { name, value: { type: "timeunit", value: 1, unit: "minutes" } } });
  } else {
    onChange({ target: { name, value: { type: "auto", scaling: 1 } } });
  }
};
const StyledFormControl = styled(FormControl)`
  padding: 0;
  border: 0;
`;
const Time = ({ index }) => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement(Field, { name: `groupBy.groupings.${index}.interval` }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "group-by-interval",
      label: t("wizard_grouping.interval"),
      error,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(TypeCheckboxWrapper, null, /* @__PURE__ */ React.createElement(Checkbox, { onChange: () => toggleIntervalType(name, value.type, onChange), checked: value.type === "auto" }, /* @__PURE__ */ React.createElement(IntervalCheckboxDesc, null))),
    value.type === "auto" && /* @__PURE__ */ React.createElement(RangeSelect, null, /* @__PURE__ */ React.createElement(Icon, { name: "zoom_out", size: "lg", style: { paddingRight: "0.5rem" } }), /* @__PURE__ */ React.createElement(
      StyledFormControl,
      {
        type: "range",
        min: 0.5,
        max: 10,
        step: 0.5,
        value: value.scaling ? 1 / value.scaling : 1,
        onChange: (e) => onChange({
          target: {
            name,
            value: { ...value, scaling: 1 / parseFloat(e.target.value) }
          }
        })
      }
    ), /* @__PURE__ */ React.createElement(Icon, { name: "zoom_in", size: "lg", style: { paddingLeft: "0.5rem" } }), /* @__PURE__ */ React.createElement(CurrentScale, null, t("wizard_grouping.scale", { scale: value.scaling ? 1 / value.scaling : 1 }))),
    value.type !== "auto" && /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(
      FormControl,
      {
        type: "number",
        value: value.value,
        step: "1",
        min: "1",
        onChange: (e) => onChange({ target: { name, value: { ...value, value: e.target.value } } })
      }
    ), /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(DropdownButton, { title: TimeUnits[value.unit] ? t(TIME_UNIT_LABELS[value.unit]) : "" }, Object.keys(TimeUnits).map((unit) => /* @__PURE__ */ React.createElement(MenuItem, { key: unit, onSelect: () => onChange({ target: { name, value: { ...value, unit } } }) }, t(TIME_UNIT_LABELS[unit]))))))
  ));
};
export default Time;
